// Request timeout (ms) for the shared API fetch instance, covering content-service
// and the other repository calls. Caps a stalled upstream so it can't hang the
// SSR render indefinitely.
export const API_REQUEST_TIMEOUT_MS = 10000

// One short retry absorbs a transient blip. ofetch retries on a timeout and on
// retryable responses (408, 409, 425, 429, 5xx).
export const API_RETRY_COUNT = 1
export const API_RETRY_DELAY_MS = 250

export function apiFetchOptions(baseURL: string) {
  return {
    baseURL,
    timeout: API_REQUEST_TIMEOUT_MS,
    retry: API_RETRY_COUNT,
    retryDelay: API_RETRY_DELAY_MS,
  }
}

// Application submits inline CV/attachment files as base64 in the JSON body, so the
// upload can take far longer than a content-service read. The 10s SSR cap above
// aborted them client-side while the request was often still in flight and about to
// succeed, leaving the candidate with a generic error on an application that went
// through (JET-2686).
export const APPLICATION_UPLOAD_TIMEOUT_MS = 120000
